export { DatastoreCurrenciesIncludingExternalModule } from './currencies-including-external.module';
export * from './currencies-including-external.types';
